<template>
  <div>
    <b-card>
      <page-title v-if="titleStatus" :title="$t('countries.items')" />

      <main-table
        :fields="fields"
        :list_url="'admin/country'"
        :reloadData="reloadData"
        :params="filter"
        :createBtnLabel="$t('countries.create')"
        createRouteName="generalSettings.countryCreate"
        :excelFields="excelFields"
        excelName="countries"
        :downloadSampleStatus="true"
        downloadSampleUrl="country/excel-sample"
        :uploadFileStatus="true"
        uploadFileUrl="country/excel"
      />
    </b-card>
  </div>
</template>
<script>
import { core } from "../../../../config/pluginInit";
import CountryFilter from "../models/CountryFilter";
import searchMixin from "../../../../Mixins/searchMixin";

export default {
  mixins: [searchMixin],
  data() {
    return {
      filter: new CountryFilter(),
      fields: [
        this.$t("global.selected"),
        { key: "id", label: this.$t("table.id"), sortable: true },
        { key: "name", label: this.$t("table.name"), sortable: true },
        {
          key: "actions",
          label: this.$t("table.actions"),
          type: "actions",
          actions: [
            {
              text: this.$t("global.view"),
              icon: "fas fa-eye",
              color: "info",
              ifNavigate: true,
              routeName: "generalSettings.countryView",
              routeParams: ["id"],
            },
            {
              text: this.$t("global.update"),
              icon: "fas fa-pen",
              color: "primary",
              ifNavigate: true,
              routeName: "generalSettings.countryUpdate",
              routeParams: ["id"],
            },
            {
              text: this.$t("global.delete"),
              icon: "fas fa-trash-alt",
              color: "danger",
              showAlert: true,
              actionHeader: this.$t("global.delete"),
              titleHeader: this.$t("countries.item"),
              textContent: "name",
              url: "admin/country",
              type: "delete",
            },
          ],
        },
      ],
      excelFields: {
        [this.$t("table.id")]: "id",
        [this.$t("table.name")]: "name",
        [this.$t("table.createdAt")]: "created_at",
      },
    };
  },
  mounted() {
    core.index();
  },
};
</script>
